import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}
& > button{
  margin-top: 20px;
  margin-bottom: 20px;
}
button{
  margin-top: 20px;
  margin-bottom: 20px;
}

main{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  height: auto;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
}

tr{
  cursor: pointer;
}

.formInfo{
  p{ 
    text-transform: capitalize;
    margin: 0px;
  }
  label{
    margin: 0px;
  }
}

.panel{
  padding: ${(props) => props.theme.spacing.spacing_03};
}

.total {
  margin-left: 20px;
}

.variation {
  background-color: ${props => props.theme.colors.primary_light};
}
`